<div *ngIf="isPageReady" class="flex flex-col h-full p-4">
  <div class="text-sm text-color-secondary mb-3">
    Enter the incoming freight charge to add to this account-owned inventory invoice for
    <strong>{{ params.accountName }}</strong>. Leave at $0.00 if no freight applies.
  </div>

  <div class="grid grid-cols-12 gap-3 items-center mb-4">
    <label for="freightAmt" class="col-span-4 font-semibold">Freight Amount</label>
    <div class="col-span-8">
      <p-inputNumber
        #firstInput
        inputId="freightAmt"
        [(ngModel)]="freightAmt"
        mode="currency"
        currency="USD"
        locale="en-US"
        [min]="0"
        [maxFractionDigits]="2"
        title="Freight Amount"
        inputStyleClass="text-right w-full"
      ></p-inputNumber>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button (click)="ok()" pButton type="button" label="Ok" title="Ok" icon="pi pi-check" class="p-button-raised"></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
